<template>
	<img v-if="isGroup()" :style="styleObject" :src="require('@/assets/group.png')" :onerror="onerror()" />
	<img v-else-if="this.avatar" :style="styleObject" :src="avatarUrl" :onerror="onerror()" />
	<img v-else src="@/assets/default_avatar.jpg" :style="styleObject" />
</template>

<script>
import { ossBaseUrl } from "@/config/env";

export default {
	name: "ChatAvatar",

	props: {
		type: {
			type: String,
			default: "personal",
		},
		avatar: {
			type: String,
			default: "",
		},
		size: {
			default: 30,
		},
		borderRadius: {
			type: String,
			default: "0px",
		},
	},

	created: function () {
		//
	},

	data() {
		return {
			styleObject: {
				width: this.size + "px",
				height: this.size + "px",
				borderRadius: this.borderRadius,
			},
		};
	},

	methods: {
		isGroup() {
			if (this.type === "group") {
				return true;
			} else {
				return false;
			}
		},
		onerror() {
			//
		},
	},

	computed: {
		avatarUrl: function () {
			return `${ossBaseUrl}/avatars/${this.avatar}?x-oss-process=image/resize,w_50`;
		},
	},
};
</script>

<style lang="less">
//
</style>
